<template>
  <div class="pt20">
    <div class="design_box_out">
      <p class="design_box_out_title"><i class="iconfont iconyou"></i>{{property.label}}</p>
      <div class="team-desc design_box">
        <div class="team-desc-body">
          <div class="team-desc-list" v-for="(item,index) in property.list" :key="index">
            <div class="team-desc-list-body">
              <div class="team-desc-list-img"
                   :style="{backgroundImage:'url('+item.pic+')',backgroundSize:'cover',backgroundPosition:'center'}">
              </div>
              <p class="team-desc-list-name">{{item.name?item.name:'姓名'}} <span>{{item.position?item.position:'职位'}}</span></p>
              <!--<p class="team-desc-list-company">公司总经理</p>-->
              <p class="team-desc-list-desc">{{item.info?item.info:'简介'}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ["property"],
    data() {
      return {
        defultImg: '/static/img/userDefult.png',
        form: {}
      };
    },
    created() {
    }
  };
</script>



